import { useRef, useState } from "react";
import Input from "components/form/Input/Input";
import { useMessageBox } from "pages/MessageBox/MessageBoxContext";
import { ReactComponent as IconSearch } from "assets/images/icons/search.svg";
import { ReactComponent as IconClose } from "assets/images/icons/close.svg";
import "pages/MessageBox/ViewConversationsHeader.scss";
import Trans from "features/translation/components/Trans";

const ViewConversationsHeader = () => {
  const [ filterVisible, setFilterVisible ] = useState();

  const filterRef = useRef();
  const [ typedFilter, setTypedFilter ] = useState('');

  const { conversations, filter, setFilter } = useMessageBox();

  const toggleFilterVisible = () => {
    const value = !filterVisible;
    setFilterVisible(() => value);
    if (!value) {
      setFilter('');
      setTypedFilter('');
    }
  }

  const handleChangeFilter = event => {
    setTypedFilter(() => event.target.value);
    clearTimeout(filterRef.current);
    filterRef.current = setTimeout(() => setFilter(event.target.value), 500);
  }

  return (
    <>
      <div className={ `conversations-header` }>
        {
          (conversations?.results?.length > 0 || filter) &&
          <div className={ `conversations-titlebar` }>
            <h3 className={ `conversations-titlebar__title` }>Gesprekken</h3>
            <div className={ `conversations-titlebar__search` } onClick={ toggleFilterVisible }>
              <div className={ `conversations-search` }>
                <div className={ `conversations-search__icon` }>
                  { filterVisible ? <IconClose/> : <IconSearch/> }
                </div>
                <div className={ `conversations-search__text` }>
                  { filterVisible ? `Zoeken sluiten` : `Zoeken op naam` }
                </div>
              </div>
            </div>
          </div>
        }
        {
          filterVisible &&
          <Input type="text"
                 placeholder={ `Typ (een deel van) een naam` }
                 value={ typedFilter }
                 onChange={ handleChangeFilter }
                 autoFocus
          />
        }
      </div>
      {
        filterVisible && !conversations?.results?.length &&
          <Trans text={ `Geen resultaten gevonden` }/>
      }
    </>
  );
}

export default ViewConversationsHeader;
